import { render, staticRenderFns } from "./linkable.vue?vue&type=template&id=85c780d8&"
import script from "./linkable.vue?vue&type=script&lang=js&"
export * from "./linkable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports